
























































































import Vue from 'vue';
import Component from 'vue-class-component';
import FormNavigationButtons from '../common/FormNavigationButtons.vue';
import { Watch, Prop } from 'vue-property-decorator';
import { Tickets } from '@/modules/shared/shared/domain/constants/constants';
import ticketsRepository from '../../../../modules/tickets/shared/repositories/tickets.repository';
import { AssistanceTypingsInterface } from '@/components/tickets/tickets-form/interfaces/assistance.typings.interface';
@Component({
    components: {
        FormNavigationButtons,
    },
})
export default class StepRequirementTicketConfirmation extends Vue {
    @Prop({ required: true })
    requirementTicket!: {
        generalInformation: {
            subject: AssistanceTypingsInterface;
            subCategory: AssistanceTypingsInterface;
            contactId: number;
            firstName: string;
            lastName: string;
            idNumber: string;
            telephoneNumber: string;
            description: string;
        };
        tapes: {
            giveOrTake: string;
            code: string;
        }[];
    };

    isFormValid: boolean = true;
    $refs!: {
        form: any;
    };

    validateStep() {
        if (this.$refs.form.validate()) {
            this.$emit('nextStep');
        }
    }

    sendRequirementTicket() {
        this.$emit('sendRequirementTicket');
    }

    previousStep() {
        this.$emit('previousStep');
    }

    reset() {
        this.$emit('reset');
    }
}
